'use client';

import { useLanguage } from '@/lib/platform/contexts/language-context';
import { ALL_COUNTRIES } from '@/lib/platform/data/countries';
import Select from './Select';

interface CountrySelectProps {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  helperText?: string;
  required?: boolean;
  disabled?: boolean;
}

export function CountrySelect({
  label = 'Country',
  value,
  onChange,
  error,
  helperText,
  required,
  disabled,
}: CountrySelectProps) {
  const { locale } = useLanguage();

  // Sort countries: DK first, then alphabetically by localized name
  const sortedCountries = [...ALL_COUNTRIES].sort((a, b) => {
    if (a.code === 'DK') return -1;
    if (b.code === 'DK') return 1;
    return a.name[locale].localeCompare(b.name[locale]);
  });

  const options = sortedCountries.map((country) => ({
    value: country.code,
    label: `${country.flag} ${country.name[locale]}`,
  }));

  return (
    <Select
      label={label}
      value={value}
      onChange={(val) => onChange(val as string)}
      options={options}
      error={error}
      helperText={helperText}
      required={required}
      disabled={disabled}
    />
  );
}
